import React, { ReactNode } from 'react';
import { FlexPanel } from '../../components/layout/flexpanel';
import { ModalPaddingType } from './Modal';

export interface ModalFooterProps {
   padding: ModalPaddingType;
   children?: ReactNode;
}

export const ModalFooter = (props: ModalFooterProps) => {

   return (
      <FlexPanel className={'uf-modal-footer'}
                 alignItems={'center'}
                 paddingLeft={'medium'}
                 paddingRight={'medium'}
                 paddingTop={'small'}
                 paddingBottom={'small'}
      >
         {props.children}
      </FlexPanel>
   );
};
